module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img-component', {
    attrs: {
      "src": "/static/images/new/3.jpg",
      "text": "Her er en billedetekst"
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/21_foto_fra_facebook.jpeg"
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('img-component', {
    attrs: {
      "src": "/static/images/new/26.jpg",
      "text": "\n                    Familien Bil tæller i dag 7 personer<br>\n                    Fra venstre Lasse, Karsten, Manna, Thomas, Peder og Matilde (Jesper mangler)\n                "
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Hvem er vi\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/6,2_new.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0 0 20px"
    }
  }, [_vm._v("\n                    Historien bag P. Pedersen & Søn\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    P. Pedersen & Søn Fragt og Vognmandsfirma blev grundlagt i 1921 og køres i dag af tredje generation.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det var farfaren Peter Pedersen som startede firmaet august 1921. På det tidspunkt transporterede han alt - sten og grus, gods, korn, dyr og mennesker – med både hestevogn og bil. Han havde også et grusværk med gravemaskiner og gummiged. Med tiden blev det dog fragt, vognmandskørsel og dagligvare distribution der vægtede mest – indtil hans død i 1977.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Sønnen Mads Pedersen begyndte i firmaet da han fik kørekort, og han overtog styringen i begyndelsen af 1970érne. Mads Pedersen døde desværre i en alder af 50 år, hvorefter hans hustru Manna Pedersen kørte virksomheden videre indtil sønnerne Peder Bil og Karsten Bil tiltrådte virksomheden i 1976.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Peder Bil gik på efterløn i 2011, men følger stadig interesseret med i virksomheden. I dag køres firmaet alene af Karsten Bil, som i øvrigt havde 45 års jubilæum 1. marts 2021. Karsten Bil har to sønner, Lasse som er chauffør i firmaet og Thomas som bor og arbejder på Sjælland som sælger.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    I årene 2008–2018 havde Karsten Bil også virksomheden Kemi-Oil ApS (forhandling af cellulosefortynder, silikonefjerner og acetone samt afhentning af spild i hele landet).\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Det gamle familiefirma, som 16. august 2021 runder 100 år, har i dag otte biler. Seks trækkere, en forvogn, en varebil + ti trailere, der dag og nat kører til og fra Ærø for at betjene beboerne, havne og virksomheder med småpakker, styk-/partigods, fødevarer, køl/frys, materialer mv.\n                ")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/22_karsten_bil_og_peder_bil.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/1_med_logo.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/2.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/5.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/7.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/8.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/6,1.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/9.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/10.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/20_forvogn.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5"
  }, [_vm._v("\n                Andet billede af hvid lastbil her - Jeg kan ikke finde billedet i de billeder, jeg har taget. Hvor kan jeg finde det i god opløsning?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/13.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/24.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/15.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/people.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/new/25.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/100_aar.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": "/static/images/Galleri_2.jpg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b24b4a1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/aboutNew.vue
// module id = 275
// module chunks = 1